module.exports = __webpack_public_path__ + "f98124afdde295636277e9456854390c.svg";